import axios from "axios";

const BASE_URL = "https://grandswiss.onrender.com/api/";
//"https://grandswiss.onrender.com/api/"
//"https://localhost:8080/api/"

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});

export const userRequest = axios.create({
  baseURL: BASE_URL,
});

export const updateTokenInHeaders = (token) => {
  userRequest.interceptors.request.use((config) => {
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
};

const initToken = () => {
  try {
    const persistedState = JSON.parse(localStorage.getItem("persist:root"));
    const token = JSON.parse(persistedState?.user || "{}")?.currentUser
      ?.accessToken;
    if (token) {
      updateTokenInHeaders(token);
    }
  } catch (error) {
    console.error("Error initializing token from localStorage:", error);
  }
};

initToken();

export const api = axios.create({
  // baseURL: "http://localhost:8080/api",
  baseURL: "https://grandswiss.onrender.com/api/",
});

export default api;
